// 21.2.5.3 get RegExp.prototype.flags()
if (require('./_descriptors') && /./g.flags != 'g') require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es6.regexp.flags.js
// module id = 107
// module chunks = 0 1 2 3 4 5 6 7 8